import { Underconstruction } from "../WorkerComp/Utils"
export default function Blog(){
    return(
        <>
        <Underconstruction name="Blog"/>
        </>
       )
}